module.exports = __webpack_public_path__ + "static/media/icon_material_developer_board.bbcb056d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_material_developer_board.svg
// module id = 709
// module chunks = 0